import { RequestConstants } from "@lib/titan2/dist/api/core/request/RequestConstants";
import { ChooseCellResponseData } from "./data/ChooseCellResponseData";
import { CollectResponseData } from "./data/CollectResponseData";
import { CurrentGameResponseData } from "./data/CurrentGameResponseData";
import { PurchaseEntryResponseData } from "./data/PurchaseEntryResponseData";
import { SpinResponseData } from "./data/SpinResponseData";
import { StakeToSpinResponseData } from "./data/StakeToSpinResponseData";
import { RequestHandler } from "./RequestHandler";
/*
 * Slingo.ts
 */
export class Slingo {
    static getCurrentGame(parameters, action, scope) {
        let URL = "/slingo/" + Slingo.gameType + "/games/" + Slingo.gameId;
        new RequestHandler(parameters, action, scope, URL, Slingo.requestsMap.getCurrentGame).run();
    }
    static purchaseEntry(parameters, action, scope) {
        let URL = "/slingo/" + Slingo.gameType + "/games/" + Slingo.gameId;
        new RequestHandler(parameters, action, scope, URL, Slingo.requestsMap.purchaseEntry).run();
    }
    static spin(parameters, action, scope) {
        let URL = "/slingo/" + Slingo.gameType + "/games/" + Slingo.gameId + "/" + Slingo.requestsMap.spin.action;
        new RequestHandler(parameters, action, scope, URL, Slingo.requestsMap.spin).run();
    }
    static chooseCell(parameters, action, scope) {
        let URL = "/slingo/" + Slingo.gameType + "/games/" + Slingo.gameId + "/" + Slingo.requestsMap.chooseCell.action;
        new RequestHandler(parameters, action, scope, URL, Slingo.requestsMap.chooseCell).run();
    }
    static collect(parameters, action, scope) {
        let URL = "/slingo/" + Slingo.gameType + "/games/" + Slingo.gameId + "/" + Slingo.requestsMap.collect.action;
        new RequestHandler(parameters, action, scope, URL, Slingo.requestsMap.collect).run();
    }
    static stakeToSpin(parameters, action, scope) {
        let URL = "/slingo/" + Slingo.gameType + "/games/" + Slingo.gameId + "/" + Slingo.requestsMap.stakeToSpin.action;
        new RequestHandler(parameters, action, scope, URL, Slingo.requestsMap.stakeToSpin).run();
    }
}
Slingo.requestsMap = {
    getCurrentGame: {
        name: "CurrentGame",
        action: "",
        dataClass: CurrentGameResponseData,
        Method: RequestConstants.GET
    },
    purchaseEntry: {
        name: "PurchaseEntry",
        action: "",
        dataClass: PurchaseEntryResponseData,
        Method: RequestConstants.POST
    },
    spin: {
        name: "Spin",
        action: "actions/SPIN",
        dataClass: SpinResponseData,
        Method: RequestConstants.PUT
    },
    chooseCell: {
        name: "ChooseCell",
        action: "actions/CHOOSE_CELL",
        dataClass: ChooseCellResponseData,
        Method: RequestConstants.PUT
    },
    collect: {
        name: "Collect",
        action: "actions/COLLECT",
        dataClass: CollectResponseData,
        Method: RequestConstants.PUT
    },
    stakeToSpin: {
        name: "StakeToSpin",
        action: "actions/STAKE_TO_SPIN",
        dataClass: StakeToSpinResponseData,
        Method: RequestConstants.PUT
    }
};
Slingo.gameType = "";
Slingo.gameId = ""; //override this with gameId
//# sourceMappingURL=Slingo.js.map